module.exports = __webpack_public_path__ + "img/thumbnail_video_basket.2a68e3a2.png";